/* Moment */
import moment from "moment"
import "moment/locale/ru"

moment.locale("ru")


/* Where an account comes from */
export const KINDS = {
    app: { text: "В приложении", hint: "Вход по коду в приложение или на сайт", accent: "blue", icon: "profile" },
    point: { text: "Завела точка", hint: "Точка записала из Bookify Pro, входа в приложение не было", accent: "violet", icon: "organization" },
    lead: { text: "Без входа", hint: "Код запрошен, но не введён — за аккаунтом ничего нет", accent: "grey", icon: "otp" }
}

/* The state of an account — nothing is ever deleted, "deleted" means the client left on their own */
export const stateOf = user => {

    if (parseInt(user.active) === 1) {
        return { key: "active", text: "Активен", accent: "green" }
    }

    if (user.deactivatedBy === "admin") {
        return { key: "blocked", text: "Заблокирован", accent: "red" }
    }

    return { key: "deleted", text: "Аккаунт удалён", accent: "orange" }
}

/* Where a booking came from — the words, the colour and the sign */
export const CHANNELS = {
    app: { text: "Приложение", color: "#0279fc", icon: "profile" },
    web: { text: "Сайт", color: "#00acc1", icon: "search" },
    "2gis": { text: "2ГИС", color: "#43a047", icon: "organization" },
    owner: { text: "Записала точка", color: "#7c4dff", icon: "booking" },
    qr: { text: "QR код", color: "#ff7a00", icon: "qr" },
    share: { text: "Ссылка", color: "#e91e63", icon: "trend" },
    whatsapp: { text: "WhatsApp", color: "#25d366", icon: "support" }
}

export const channelOf = key => {
    return CHANNELS[key] ? CHANNELS[key] : { text: key ? key : "—", color: "#90a4ae", icon: "booking" }
}

/* The states of a visit with the colours of the applications */
export const BOOKING_STATUSES = {
    0: { text: "Ожидание", accent: "green" },
    1: { text: "Принята", accent: "violet" },
    2: { text: "Завершена", accent: "blue" },
    3: { text: "Отменена", accent: "red" },
    4: { text: "Не пришёл", accent: "red" }
}

/* A date as a person says it: "сегодня", "3 дня назад", "в марте" */
export const ago = value => {

    if (!value) {
        return null
    }

    const date = moment(value)
    const days = moment().startOf("day").diff(moment(date).startOf("day"), "days")

    if (days === 0) {
        return date.isAfter(moment()) ? `сегодня в ${date.format("HH:mm")}` : "сегодня"
    }

    if (days === 1) {
        return "вчера"
    }

    if (days === -1) {
        return "завтра"
    }

    return date.fromNow()
}

/* The first letters of a name for an avatar without a photo */
export const initialsOf = name => {

    const words = `${name || ""}`.trim().split(/\s+/).filter(word => word.length > 0)

    if (words.length === 0) {
        return "?"
    }

    return words.slice(0, 2).map(word => word[0].toUpperCase()).join("")
}

/* Each person gets a colour of the avatar of his own */
const AVATARS = ["#0279fc", "#7c4dff", "#e91e63", "#00a884", "#ff7a00", "#00acc1", "#5c6bc0", "#f4511e"]

export const avatarColorOf = id => {
    return AVATARS[(parseInt(id) || 0) % AVATARS.length]
}

/* The digits of a phone for the links of WhatsApp and the calls */
export const digitsOf = phone => {
    return `${phone || ""}`.replace(/\D/g, "")
}
